import { render, staticRenderFns } from "./FieldPlanTaskDuration.vue?vue&type=template&id=4549df56&scoped=true"
import script from "./FieldPlanTaskDuration.vue?vue&type=script&lang=js"
export * from "./FieldPlanTaskDuration.vue?vue&type=script&lang=js"
import style0 from "./FieldPlanTaskDuration.vue?vue&type=style&index=0&id=4549df56&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4549df56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4549df56')) {
      api.createRecord('4549df56', component.options)
    } else {
      api.reload('4549df56', component.options)
    }
    module.hot.accept("./FieldPlanTaskDuration.vue?vue&type=template&id=4549df56&scoped=true", function () {
      api.rerender('4549df56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldPlanTaskDuration.vue"
export default component.exports